import isAbsoluteURL from "./axios30.js";
import combineURLs from "./axios31.js";
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}
export {
  buildFullPath as default
};
//# sourceMappingURL=axios21.js.map
